import * as types from "../types";

const initialState = {
    loading: false,
    otpReq: null,
    otpResult: null,
    error: null
}

export default function otpReducer(state = initialState, action){
    
    switch(action.type){

        case types.OTP_REQUEST :
            return{
                ...state,
                loading: true,
                otpReq: action.payload.otpReq,
            }

        case types.OTP_SUCCESS :
            return{
                ...state,
                loading: false,
                otpResult: action.payload.otpResult,
            }

        case types.OTP_FAILURE :
            return{
                ...state,
                loading: false,
                otpReq: null,
                otpResult: null,
                error: action.payload.error
            }

        case types.OTP_RESET :
            return{
                ...state,
                loading: false,
                otpReq: null,
                otpResult: null,
                error: null
            }
    

        default :
        return state;

    }

}